import React from "react";
import "./PoliciesPages.scss";

const HouseRules = () => {
    return (
        <div className="policy-page">
            <h1>House Rules</h1>
            <p>Last updated: January 2025</p>

            <h2>1. Age Requirement</h2>
            <p>Guests must be 18+. Valid ID is required.</p>

            <h2>2. Behaviour</h2>
            <ul>
                <li>No aggressive or antisocial behaviour.</li>
                <li>No illegal substances.</li>
                <li>No outside food or drink.</li>
            </ul>

            <h2>3. Shisha Safety</h2>
            <ul>
                <li>Do not touch hot coals.</li>
                <li>Report any equipment damage immediately.</li>
                <li>Use shisha at your own risk.</li>
            </ul>

            <h2>4. Smoking Areas</h2>
            <p>Smoking is allowed only in designated areas according to UK law.</p>

            <h2>5. Staff Instructions</h2>
            <p>Please follow the instructions of our staff at all times.</p>
        </div>
    );
};

export default HouseRules;
